import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to handle scrolling to sections based on URL hash or scroll to top
 * @param {Object} options - Configuration options
 * @param {boolean} options.scrollToTop - Whether to scroll to top when no hash is present (default: true)
 * @param {string} options.behavior - Scroll behavior ('smooth' or 'auto', default: 'smooth')
 * @param {string} options.block - Scroll block alignment ('start', 'center', 'end', 'nearest', default: 'center')
 */
export const useScrollToSection = (options = {}) => {
  const {
    scrollToTop = true,
    behavior = 'smooth',
    block = 'center'
  } = options;

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // Scroll to specific section if hash is present
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior, block });
      }
    } else if (scrollToTop) {
      // Scroll to top when no hash is present
      window.scrollTo({ top: 0, behavior });
    }
  }, [location, scrollToTop, behavior, block]);
};

export default useScrollToSection;